module.exports = __webpack_public_path__ + "static/media/how_to_be_well_read.d22e9592.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/books/how_to_be_well_read.jpg
// module id = 89
// module chunks = 0